import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './alert-something.module.css';

class alertSomething extends React.Component {
  constructor(props) {
    super(props);
    bindAll(this,[
        'onClose'
    ])
    this.state = {
        show: false,
        title: '升级提示',
        message: '为了给您带来更好的课程体验，此课程场次进行了升级。当前版本暂不支持该功能，需要将客户端更新到最新版本哦！'
    }
    Object.assign(window.Xes, {
      alertSomething: (config) => {
        this.setState({
            show: true,
            title: (config && config.title) || this.state.title,
            message: (config && config.message) || this.state.message,
        })
      }
    })
  }
  onClose () {
      this.setState({show: false})
  }
  render () {
    return (
      <div className={this.state.show ? styles.wraper : styles.hide} >
        <div className={styles.card}>
            <div className={styles.title}>{this.state.title}</div>
            <div className={styles.message}>{this.state.message}</div>
            <div className={styles.confirm} onClick={this.onClose}></div>
        </div>
      </div>
    )
  }
}
export default alertSomething